<app-table
    tableKey="dashboardSuggestion"
    [gridData]="$any(store.data.getWorks())"
    [hideCheckboxes]="true"
    [columns]="columns()"
    translatePrefix="workData.suggestion."
    [showSearch]="false"
    [showColumnVisiblity]="false"
    [showExport]="false"
    [showClearFilter]="false"
    [additionalFilter]="additionalFilters()"
    [refreshCallback]="store.api.getWorks"
    [refreshCallbackFragment]="getSuggestionsFrag"
    [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
    (detailCallback)="detail($event)"
>
    <ng-template pTemplate="dateFrom" let-item="item">
        {{ item.dateFrom | localDate: 'd.M.y' }}
        @if (item | suggestionDaysLeft; as days) {
            <app-button
                [text]="true"
                [label]="days | formatDaysDiff"
                [severity]="(days <= 0
                    ? 'danger'
                    : (days < 7
                        ? 'warn'
                        : 'success'
                    )
                )"
            ></app-button>
        }
    </ng-template>
</app-table>
